import {
  REVIEW_PRODUCT_FAILURE,
  REVIEW_PRODUCT_REQUEST,
  REVIEW_PRODUCT_SUCCESS,
  GET_PRODUCT_REVIEW_REQUEST,
  GET_PRODUCT_REVIEW_SUCCESS,
  GET_PRODUCT_REVIEW_FAILURE,
} from "../actions/productReviewAction";

const createProductReviewState = {
  loading: false,
  data: null,
  error: null,
};

export const productReviewReducer = (
  state = createProductReviewState,
  action
) => {
  switch (action.type) {
    case REVIEW_PRODUCT_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case REVIEW_PRODUCT_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
      };
    case REVIEW_PRODUCT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

const getProductReviewState = {
  loading: false,
  data: {},
  error: null,
};

export const getProductReviewReducer = (
  state = getProductReviewState,
  action
) => {
  switch (action.type) {
    case GET_PRODUCT_REVIEW_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case GET_PRODUCT_REVIEW_SUCCESS:
      // const newEntry = { [action.payload.product_id]: action.payload };
      // state.data.push(newEntry);
      // const newData = state.data;

      return {
        ...state,
        loading: false,
        data: {
          ...state.data,
          [action.payload.product_id]: action.payload, // store by product ID
        },
        error: null,
      };

    case GET_PRODUCT_REVIEW_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};
